<h1>Área Administrativa - Informações do Cliente</h1>

<div class="load-response" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>

<div class="content" *ngIf="pdvs?.length && !loading">
    <div *ngFor="let pdv of pdvs" class="pdv-box">
        <h3>{{ pdv.pdvDescription | uppercase }}</h3>

        <table mat-table [dataSource]="pdv.tags" class="demo-table">
            <ng-container matColumnDef="tagName">
                <th mat-header-cell *matHeaderCellDef> Tag </th>
                <td mat-cell *matCellDef="let tag">{{ tag.name }}</td>
            </ng-container>

            <ng-container matColumnDef="tagValue">
                <th mat-header-cell *matHeaderCellDef> Valor da tag </th>
                <td mat-cell *matCellDef="let tag">{{ tag.value }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['tagName', 'tagValue']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['tagName', 'tagValue']"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="2">Nenhuma informação encontrada.</td>
            </tr>
        </table>
    </div>
</div>

<div class="load-response" *ngIf="!pdvs?.length && !loading">
    <p>Nenhum PDV encontrado para este cliente.</p>
</div>